{
  "name": "@jspsych-contrib/plugin-vaast-fixation",
  "version": "0.0.1",
  "description": "This plugin is meant to be used in a VAAST (Visual Approach and Avoidance by the Self Task) experiment. The VAAST-fixation plugin displays a fixation text that is usually a cross. This plugin is usually called before a vaast-text or vaast-image trial. The participant doesn't respond to the fixation trial.",
  "type": "module",
  "main": "dist/index.cjs",
  "exports": {
    "import": "./dist/index.js",
    "require": "./dist/index.cjs"
  },
  "typings": "dist/index.d.ts",
  "unpkg": "dist/index.browser.min.js",
  "files": [
    "src",
    "dist"
  ],
  "source": "src/index.ts",
  "scripts": {
    "test": "jest",
    "test:watch": "npm test -- --watch",
    "tsc": "tsc",
    "build": "rollup --config",
    "build:watch": "npm run build -- --watch"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/jspsych/jspsych-contrib.git",
    "directory": "packages/plugin-vaast-fixation"
  },
  "author": {
    "name": "Cédric Batailler",
    "url": "https://github.com/cedricbatailler"
  },
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/jspsych/jspsych-contrib/issues"
  },
  "homepage": "https://github.com/jspsych/jspsych-contrib/tree/main/packages/plugin-vaast-fixation",
  "peerDependencies": {
    "jspsych": ">=8.0.0"
  },
  "devDependencies": {
    "@jspsych/config": "^3.2.2",
    "@jspsych/test-utils": "^1.0.0",
    "jspsych": "^8.0.0"
  }
}
